import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function PricingTableRender({ node }) {
  const content = node.content || {};
  
  const title = content.title || 'Basic Plan';
  const price = content.price || '€19.99';
  const period = content.period || '/ Monat';
  const features = (content.features || 'Merkmal 1, Merkmal 2, Merkmal 3').split(',').map(f => f.trim()).filter(Boolean);
  const buttonText = content.buttonText || 'Jetzt buchen';
  
  const isFeatured = content.isFeatured === 'true'; // string von select box
  const highlightColor = content.highlightColor || 'var(--tef-primary, #00A9E0)';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      background: 'rgba(255,255,255,0.02)',
      border: isFeatured ? `2px solid ${highlightColor}` : '1px solid rgba(255,255,255,0.05)',
      borderRadius: '16px',
      padding: '32px 24px',
      position: 'relative',
      overflow: 'hidden',
      height: '100%',
      transform: isFeatured ? 'scale(1.02)' : 'scale(1)',
      transition: 'transform 0.3s ease',
      boxShadow: isFeatured ? `0 10px 40px -10px ${highlightColor}44` : 'none'
    }}>
      {isFeatured && (
        <div style={{
          position: 'absolute', top: 0, right: 0,
          background: highlightColor, color: '#fff',
          padding: '4px 24px', fontSize: '12px', fontWeight: 'bold',
          transform: 'rotate(45deg) translate(20px, -10px)' // Ecken-Banner
        }}>
          Bestseller
        </div>
      )}

      <h3 style={{ margin: '0 0 16px', fontSize: '20px', color: '#cbd5e1', fontWeight: '600', textAlign: 'center' }}>
        {title}
      </h3>
      
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <span style={{ fontSize: '42px', fontWeight: '900', color: '#fff', letterSpacing: '-1px' }}>{price}</span>
        <span style={{ fontSize: '14px', color: '#64748b', marginLeft: '4px' }}>{period}</span>
      </div>

      <ul style={{ listStyle: 'none', margin: '0 0 32px 0', padding: 0, flex: 1 }}>
        {features.map((f, i) => (
          <li key={i} style={{ padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.05)', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: highlightColor }}>✓</span> {f}
          </li>
        ))}
      </ul>

      <button style={{
        width: '100%',
        padding: '14px',
        borderRadius: '8px',
        border: 'none',
        background: isFeatured ? highlightColor : 'rgba(255,255,255,0.05)',
        color: isFeatured ? '#fff' : '#cbd5e1',
        fontWeight: 'bold',
        fontSize: '16px',
        cursor: 'pointer',
        transition: 'background 0.2s'
      }}>
        {buttonText}
      </button>
    </div>
  );
}

registry.register('PricingTable', {
  label: 'Preiskarte (Typisch)',
  icon: '💳', 
  category: 'advanced',
  component: PricingTableRender,
  
  defaultProps: {
    content: {
      title: 'O2 Mobile M',
      price: '29,99€',
      period: '/ Monat',
      features: '25 GB Daten, Allnet Flat, 5G Netz, Inkl. Roaming',
      buttonText: 'Tarif wählen',
      isFeatured: 'false',
      highlightColor: '#00A9E0'
    },
    style: {
      desktop: {
        width: '100%',
        margin: '10px 0'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Kopfbereich',
          fields: [
            { name: 'content.title', label: 'Planname / Tarif', type: 'text' },
            { name: 'content.price', label: 'Preis', type: 'text' },
            { name: 'content.period', label: 'Dauer', type: 'text' }
          ]
        },
        {
          title: 'Inhalt & Button',
          fields: [
            { name: 'content.features', label: 'Features (kommasepariert)', type: 'textarea' },
            { name: 'content.buttonText', label: 'Button-Label', type: 'text' }
          ]
        },
        {
          title: 'Hervorhebung',
          fields: [
            { name: 'content.isFeatured', label: 'Als "Bestseller" hervorheben?', type: 'select', options: ['false', 'true'] },
            { name: 'content.highlightColor', label: 'Akzentfarbe', type: 'color' }
          ]
        }
      ]
    }
  ]
});
